import React, { forwardRef, useEffect, useImperativeHandle } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import api from "../../../../config/URL";
import { toast } from "react-toastify";
import { dark } from "@mui/material/styles/createPalette";
import PhoneInput from "react-phone-input-2";

const validationSchema = Yup.object().shape({
  address: Yup.string().required("*Address is required"),
  postalCode: Yup.string()
    .matches(/^[0-9]+$/, "*Postal Code must contain only numbers")
    .min(4, "*Postal Code must be at least 4 digits")
    .max(6, "*Postal Code can't be longer than 6 digits")
    .required("*Postal Code is required"),
  nameOfEmergency: Yup.string().required(
    "*Emergency Contact Person is required"
  ),
  emergencyNric: Yup.string().required("*Contact Person NRIC is required"),
  emergencyContact: Yup.string()
    .matches(/^\+\d{10,15}$/, "*Invalid Phone Number")

    .required("*Emergency Person Contact Number is required"),
  relationToChild: Yup.string().required("*Relationship is required"),
  contactOfAuthorised: Yup.string()
    .matches(/^\+\d{10,15}$/, "*Invalid Phone Number")
    .notRequired("*Invalid Phone Number"),
});

const EditForm4 = forwardRef(
  ({ formData, setLoadIndicators, setFormData, handleNext }, ref) => {
    const userName = localStorage.getItem("userName");
    const formik = useFormik({
      initialValues: {
        address: formData.address || "",
        postalCode: formData.postalCode,
        nameOfEmergency: formData.nameOfEmergency || "",
        emergencyNric: formData.emergencyNric || "",
        emergencyContact: formData.emergencyContact || "",
        relationToChild: formData.relationToChild || "",
        nameOfAuthorised: formData.nameOfAuthorised || "",
        relationToChils: formData.relationToChils || "",
        noAuthorisedNric: formData.noAuthorisedNric || "",
        contactOfAuthorised: formData.contactOfAuthorised || "",
        updatedBy: userName,
      },
      validationSchema: validationSchema,
      onSubmit: async (data) => {
        setLoadIndicators(true);
        data.updatedBy = userName;
        try {
          const response = await api.put(
            `/updateLeadInfo/${formData.id}`,
            data,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          if (response.status === 200) {
            toast.success(response.data.message);
            setFormData((prv) => ({ ...prv, ...data }));
            handleNext();
          } else {
            toast.error(response.data.message);
          }
        } catch (error) {
          toast.error(error);
        } finally {
          setLoadIndicators(false);
        }
      },
      validateOnChange: false, // Enable validation on change
      validateOnBlur: true, // Enable validation on blur
    });

    // Function to scroll to the first error field
    const scrollToError = (errors) => {
      const errorField = Object.keys(errors)[0]; // Get the first error field
      const errorElement = document.querySelector(`[name="${errorField}"]`); // Find the DOM element
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
        errorElement.focus(); // Set focus to the error element
      }
    };

    // Watch for form submit and validation errors
    useEffect(() => {
      if (formik.submitCount > 0 && Object.keys(formik.errors).length > 0) {
        scrollToError(formik.errors);
      }
    }, [formik.submitCount, formik.errors]);

    useEffect(() => {
      const getData = async () => {
        const response = await api.get(`/getAllLeadInfoById/${formData.id}`);
        formik.setValues(response.data);
        formik.setValues({
          ...response.data,
          relationToChils: response.data.relation,
        });
        console.log("relationToChils", response.data.relation);
      };
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      getData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useImperativeHandle(ref, () => ({
      editform4: formik.handleSubmit,
    }));

    return (
      <form onSubmit={formik.handleSubmit}>
        <div className="container py-4">
          <h5 className="headColor mb-5">Address</h5>
          <div className="row">
            <div className="col-md-12 col-12">
              <div className="mb-3">
                <div>
                  <label for="exampleFormControlInput1" className="form-label">
                    Address
                    <span className="text-danger">*</span>
                  </label>
                </div>
                <div className="">
                  <textarea
                    type="text"
                    name="address"
                    className="form-control"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.address}
                  />
                  {formik.touched.address && formik.errors.address && (
                    <div className="error text-danger ">
                      <small>{formik.errors.address}</small>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="mb-3">
                <label for="exampleFormControlInput1" className="form-label">
                  Postal Code<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control "
                  name="postalCode"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.postalCode}
                />
                {formik.touched.postalCode && formik.errors.postalCode && (
                  <div className="error text-danger ">
                    <small>{formik.errors.postalCode}</small>
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="mb-3">
                <label for="exampleFormControlInput1" className="form-label">
                  Name Of Emergency Contact Person's (Other Than Parents)
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control "
                  name="nameOfEmergency"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.nameOfEmergency}
                />
                {formik.touched.nameOfEmergency &&
                  formik.errors.nameOfEmergency && (
                    <div className="error text-danger ">
                      <small>{formik.errors.nameOfEmergency}</small>
                    </div>
                  )}
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="mb-3">
                <label for="exampleFormControlInput1" className="form-label">
                  Emergency Contact Person's NRIC/FIC No. (other Than Parents)
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control "
                  name="emergencyNric"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.emergencyNric}
                />
                {formik.touched.emergencyNric &&
                  formik.errors.emergencyNric && (
                    <div className="error text-danger ">
                      <small>{formik.errors.emergencyNric}</small>
                    </div>
                  )}
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="mb-3">
                <label for="exampleFormControlInput1" className="form-label">
                  Emergency Contact Person's Contact Number (other Than Parents)
                  <span className="text-danger">*</span>
                </label>
                <PhoneInput
                  country={"sg"}
                  enableSearch={true}
                  inputProps={{
                    name: "emergencyContact",
                    required: true,
                    onBlur: formik.handleBlur,
                  }}
                  value={formik.values.emergencyContact}
                  onChange={(phone) =>
                    formik.setFieldValue("emergencyContact", "+" + phone)
                  }
                  containerClass="phone-input-container"
                  inputClass="phone-input"
                  buttonClass="phone-flag-button"
                />
                {formik.touched.emergencyContact &&
                  formik.errors.emergencyContact && (
                    <div className="error text-danger ">
                      <small>{formik.errors.emergencyContact}</small>
                    </div>
                  )}
              </div>
            </div>
            <div className="col-md-12 col-12 ">
              <div className="mb-3">
                <div>
                  <label for="exampleFormControlInput1" className="form-label">
                    Relation To Child<span className="text-danger">*</span>
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="relationToChild"
                    value="AUNTY"
                    checked={formik.values.relationToChild === "AUNTY"}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  <label className="form-check-label" for="inlineRadio1">
                    Aunty
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="relationToChild"
                    value="UNCLE"
                    checked={formik.values.relationToChild === "UNCLE"}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  <label className="form-check-label" for="inlineRadio2">
                    Uncle
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="relationToChild"
                    value="GRANDPARENTS"
                    checked={formik.values.relationToChild === "GRANDPARENTS"}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  <label className="form-check-label" for="inlineRadio2">
                    GrandParents
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="relationToChild"
                    value="HELPER"
                    checked={formik.values.relationToChild === "HELPER"}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  <label className="form-check-label" for="inlineRadio2">
                    Helper
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="relationToChild"
                    value="OTHERS"
                    checked={formik.values.relationToChild === "OTHERS"}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  <label className="form-check-label" for="inlineRadio2">
                    Others
                  </label>
                </div>
                {formik.touched.relationToChild &&
                  formik.errors.relationToChild && (
                    <div className="error text-danger ">
                      <small>{formik.errors.relationToChild}</small>
                    </div>
                  )}
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="mb-3">
                <label for="exampleFormControlInput1" className="form-label">
                  Name Of Authorised Person To Take child From Class (Other Than
                  Parents-For Pickups)
                </label>
                <input
                  type="text"
                  className="form-control "
                  name="nameOfAuthorised"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.nameOfAuthorised}
                />
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="mb-3">
                <label for="exampleFormControlInput1" className="form-label">
                  Relation To Child Of Authorised Person To Take Child From
                  Class (Other Than Parents-For Pickups)
                </label>

                <select
                  name="relationToChils"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="form-select "
                  aria-label=" example"
                  value={formik.values.relationToChils}
                >
                  <option value=""></option>
                  <option value="Father">Father</option>
                  <option value="Mother">Mother</option>
                  <option value="Grandparents">Grandparents</option>
                  <option value="Helper">Helper</option>
                  <option value="Others">Others</option>
                </select>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="mb-3">
                <label for="exampleFormControlInput1" className="form-label">
                  NRIC/FIN No. Authorised Person To Take Child From Class (Other
                  Than Parents-For Pickups)
                </label>
                <input
                  type="text"
                  className="form-control "
                  name="noAuthorisedNric"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.noAuthorisedNric}
                />
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="mb-3">
                <label for="exampleFormControlInput1" className="form-label">
                  Contact Number Authorised Person To Take Child From Class
                  (Other Than Parents-For Pickups)
                </label>
                <PhoneInput
                  country={"sg"}
                  enableSearch={true}
                  inputProps={{
                    name: "contactOfAuthorised",
                    required: true,
                    onBlur: formik.handleBlur,
                  }}
                  value={formik.values.contactOfAuthorised}
                  onChange={(phone) =>
                    formik.setFieldValue("contactOfAuthorised", "+" + phone)
                  }
                  containerClass="phone-input-container"
                  inputClass="phone-input"
                  buttonClass="phone-flag-button"
                />
                {formik.touched.contactOfAuthorised &&
                  formik.errors.contactOfAuthorised && (
                    <div className="error text-danger ">
                      <small>{formik.errors.contactOfAuthorised}</small>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
);
export default EditForm4;
